
import Vue from 'vue';
import {
  Label,
  LabelAssignment,
  LabelPickerAdvancedLabelStatus,
  LabelWithStateAndSuggestions,
  MlSuggestion,
} from '@/model';
import LabelWithSuggestionIcons from '@/components/LabelWithSuggestionIcons.vue';
import LabelPickerAdvancedFilters from '@/components/LabelPickerAdvancedFilters.vue';
import labels from '@/store/labels';
import { autoAddSpecForType } from '@/store/ui-config';
import { distinct } from '@/util/array-util';

type LabelGroup = { group: string; members: readonly LabelWithStateAndSuggestions[] };

export default Vue.extend({
  name: 'LabelPickerAdvanced',
  components: { LabelWithSuggestionIcons, LabelPickerAdvancedFilters },

  props: {
    value: { type: Array as () => LabelAssignment[], required: true },
    documentId: { type: Number as () => number | undefined },
    ingestSuggestions: { type: Array as () => number[], default: () => [] },
    documentLabels: { type: Array as () => number[], default: () => [] },
    intersectingLabels: { type: Array as () => number[], default: () => [] },
    isBusy: { type: Boolean, default: false },
    mlSuggestions: { type: Map as any as () => Map<number, MlSuggestion> },
    contextLabels: { type: Array as () => Label[], default: () => [] },
    labelStatus: { type: Object as () => LabelPickerAdvancedLabelStatus, required: true },
  },

  computed: {
    currentSelection(): number[] {
      return distinct([...this.value.map((v) => v.labelId), ...this.intersectingLabels]);
    },
  },

  data() {
    return {
      options: [] as Array<LabelGroup>,
    };
  },

  methods: {
    input(vs: LabelAssignment[]) {
      this.$emit('input', vs);
    },
    onChipClicked(label: LabelWithStateAndSuggestions, event?: MouseEvent) {
      if (event?.shiftKey) {
        this.$emit('togglePin', label.id);
        return;
      }
      if (this.value.some((v) => v.labelId === label.id)) {
        this.input(this.value.filter((v) => v.labelId !== label.id));
        return;
      }
      // 'related' is a client-only UI hint; don't persist it as suggestion provenance.
      const persistedSuggestions = label.suggestions?.filter((s) => s.type !== 'related');
      const additions: LabelAssignment[] = [{ labelId: label.id, suggestions: persistedSuggestions }];
      const selectedIds = new Set(this.value.map((v) => v.labelId));
      const toAdd = new Set(autoAddSpecForType(label.type).add);
      labels.state.labels
        .filter((l) => toAdd.has(l.code) && !selectedIds.has(l.id))
        .forEach((l) => additions.push({ labelId: l.id }));
      this.input([...this.value, ...additions]);
    },
  },
});

